export default {
  //Latvian lv(langauge code) LV(countrycode) Latvija / Latvian
  LandingPage: {
    intro_sub:
      'Dod iepakojumam otru iespēju un līdzdarbojies vides aizsardzībā',
    title: 'Samsung Upcycle-Packaging',
    sequence1_1: 'Pievienojies mums un samazini atkritumu daudzumu',
    sequence1_2:
      'ilgtspējīgai videi – pārvērt produktu iepakojumu jaunos priekšmetos.',
    sequence2_1: 'Iepazīstieties ar Samsung Upcycle-Packaging',
    sequence2_2:
      'Produktu iepakojums ir veidots tā, lai no tā kastes varētu izgatavot dažādus sadzīves priekšmetus. ',
    sequence3_1: 'Pievērs uzmanību raustītajām līnijām uz iepakojuma',
    sequence3_2:
      'Sekojot norādījumiem, izgriez detaļas, savieno tās un izveido dažādus priekšmetus. ',
    sequence4_1: 'Izvēlies, ko vēlies izveidot',
    sequence4_2:
      'No zemāk esošā piedāvājumu klāsta, izvēlies sava produktu iepakojumu, apskati dažādos dizaina variantus un iespējas. Pēc tam, kad esi izraudzījies sev tīkamāko, radošais izstrādes process var sākties!',
    selectBox: 'Izvēlies savu produktu',
    moreActivity:
      "Uzzināt vairāk par Samsung ilgtspējas aktivitātēm",    
    OLED: 'OLED',
    QLED8K: 'QLED', //update
    UHD: 'UHD', //update
    FHD: 'FHD',
    HD: 'HD',
    theFrame: 'The Frame', //update
    theSerif: 'The Serif', //update
    theSero: 'The Sero', //update
    theTerrace: 'The Terrace', //update
    thePremiere: 'The Premiere', //update
    Monitors: 'Monitori', //update
    OdysseyArk:"Odyssey Ark",
    QSoundbar: 'Q Soundbar', //update
    Soundbar: 'Soundbar', //update
    SoundbarSet01:'Soundbar Set 1',
    SoundbarSet02:'Soundbar Set 2',
    TheTerraceSoundbar:'The Terrace Soundbar',
    Soundtower:'Sound Tower',
    BespokeJet: 'BESPOKE Jet\n (Jet)',
    BespokeJetStation:'BESPOKE Jet\n (Clean Station™)',
    BespokeJetNCleanStation : 'BESPOKE Jet&\nClean Station™',
    BespokeJetNCleanStation2 : 'BESPOKE Jet&Clean Station™',
    BespokeCube53:'BESPOKE Cube™ AIR\n(53㎡)',
    BespokeCube70:'BESPOKE Cube™ AIR\n(70㎡)',
    BespokeCube106:'BESPOKE Cube™ AIR\n(106㎡)',
    BespokeCube123:'BESPOKE Cube™ AIR\n(123㎡)',
    Qooker:'Qooker',
    BespokeSlim:'BESPOKE \nSlim',
    TheFreeStyle:"The Freestyle",
    BespokeSlimCleanStation:"BESPOKE Slim&Jet\n(Clean Station™)",
    JetCleanStation:"Jet&\nClean Station™",
    JetCleanStation2:"Jet&Clean Station™",
    BlueSky:"BlueSky \n5500",
    BlueSky3000:"BlueSky \n3000",
    BlueSky3100:"BlueSky \n3100",
    BlueSky5000:"BlueSky \n5000",
    BespokeJetbot:"BESPOKE\n Jet Bot",
    BespokeJetbot2:"BESPOKE Jet Bot",
    BespokeJetbotPlus:"BESPOKE\n Jet Bot+",
    BespokeJetbotPlus2:"BESPOKE Jet Bot+",
    BespokeJetbotAI:"BESPOKE\n Jet Bot AI",
    BespokeJetbotAI2:"BESPOKE Jet Bot AI",
    Canister01:"Canister \n01",
    Canister02:"Canister \n02",
    Jupiter:"Vacuum \nCleaner",
    ref_cube:"BESPOKE Cube",
    WaterPurifier:"Water Purifier",
    LATIN:"LATIN",
    LATIN10:"LATIN10",
    MIRROR:"MIRROR",
    MW5100J:"MW5100J",
    STENA:"STENA",
    // moreActivityLink:
    //   'https://www.samsung.com/lv/sustainability/overview/',
    // moreActivityLink:'https://www.samsung.com/lv/aboutsamsung/sustainability/strategy/',
    moreActivityLink: 'https://www.samsung.com/lv/sustainability/overview/',
    footer: `
    Autortiesības© 2019-2021 Samsung. Visas tiesības aizsargātas`,
  },
  ProductPage: {
    selectDesign: 'Izvēlies dizainu, kuru vēlies izveidot',
    selectDesignDezeen: 'Samsung X Dezeen', //update
    selectDesignSoccer: 'Samsung X Football', 
    tvConsole: 'TV konsoles statīvs',
    StorageBox: 'Kaste dažādu lietu uzglabāšanai',
    MagazineRack: 'Žurnālu statīvs',
    CatHouse: 'Mājiņa kaķim',
    CatTunnel: 'Tunelis kaķim',
    BookShelf: 'Plaukts grāmatām',
    DeskShelf: 'Galda plauktiņš',
    BlackRhino: 'Melnais degunradzis \n (apdraudēta suga)', //update
    PolarBear: 'Polārlācis \n (apdraudēta suga)', //update
    SeaTurtle: 'Jūras bruņurupucis \n (apdraudēta suga) ', //update
    TheRider: 'Šūpuļzirdziņš', //update
    Kibe: 'Plauktiņš (pakāpenisks)', //update
    Tessellate: 'Plauktu sistēma', //update
    Twist: 'Grozs', //update
    AlexCouchArmTable: 'Dīvāna roku \n balsta paliktnis', //update
    BlastOffClubHouse: 'Rotaļu namiņš', //update
    KinokoTable: 'Naktsskapītis', //update
    Magnuss: 'Plauktiņš \n– mošķis', //update
    GIO: 'Puķu poda \n statīvs', //update
    PostCardPlanter: 'Pastkaršu \n turētājs', //update
    SneakerRack: 'Sneaker \n Rack', //update
    TheSoban: 'Maza izmēra \n pārvietojamais galdiņš', //update
    ToolBox: 'Darba rīku kaste', //update
    DeskStationary: 'Rakstāmlietu organizators',
    CoinBank: 'Krājkase',
    MobileScanner:'Skenera statīvs viedtālrunim',
    TabletScanner:'Skenera statīvs planšetdatoram',
    PetStairs:'Mājdzīvnieku kāpnes',
    PetFurniture: 'Pet Friendly Furniture',
    ShoeRackA:'Shoe Rack_A',
    ShoeRackB:'Shoe Rack_B',
    WineRackDog:'Wine Rack Dog',
    WineRack:'Wine Rack',
    mins: 'minūtes',
    all:'ALL',
    in: 'iekšā',
    inOnly: 'tikai',
    allBoxSize: 'Visi iepakojuma izmēri',
    soccergoalpost:'Mini Soccer Goal Post',
   soccerboard:'Table Soccer Board',
   sixpackcarrier:'Six Pack Carrier',
   trophytable:'Trophy Cup Table',
   megaphone:'Cheer Megaphone',
   FreestyleBear:'Small \n Animals \n Polar Bear',
   FreestyleRay:'Small \n Animals \n Ray',
   FreestyleRhino:'Small \n Animals \n Black Rhino',
   FreestyleSeahorse:'Small \n Animals \n See Horse',
   FreestyleWhale:'Small \n Animals \n Whale',
   Mickey:'Mickey Mouse',
   Pluto:'Pluto',
   Diseny:'Samsung X Disney'
  },
  DetailGuidePage: {
    1:'1',
    2:'2',
    3:'3',
    instructions: 'pamācība',
    prepare: 'Sagatavo kasti',
    LetsDesign: "Ķeries pie darba",
    drawParts: 'Uzzīmē detaļas uz kastes',
    note1: 'Grafiskais dizains un izmērs var atšķirties atkarībā valsts',
    note2: 'Sākumā zīmējumu ieskicē, lai pārliecinātos, ka tas ietilpst atvēlētajā vietā uz kastes  ',
    numberSpace: 'skaitlis = atstarpes starp punktiem',
    diagonal: 'diagonāle',
    LEFT: 'KREISĀ  (puse)',
    RIGHT: 'LABĀ (puse)',
    TOP: 'AUGŠA',
    TOP1: 'AUGŠA 1',
    TOP2: 'AUGŠA 2',
    BACK: 'AIZMUGURE',
    MIDDLE: 'VIDUSDAĻA',
    MIDDLE2: 'VIDUSDAĻA 2',
    BOTTOM: 'APAKŠĒJĀ DAĻA',
    FRONT: 'PRIEKŠĒJĀ DAĻA',
    SIDE: 'SĀNS',
    secondSIDE: 'OTRA PUSE',
    secondSIDE1: 'OTRA PUSE 1',
    secondSIDE2: 'OTRA PUSE 2',
    LEG: 'KĀJA', //update
    JOINT: 'ĶERMEŅA DAĻA', //update
    FACE: 'SEJAS DAĻA', //update
    DRAWERBOTTOM: 'ATVILKTNES APAKŠA', //update
    DRAWERSIDE: 'ATVILKTNES SĀNS', //update
    NOSE: 'DEGUNS', //update
    HANDLE: 'ROKTURIS', //update
    BOTTOMSIDE: 'APAKŠPUSE', //update
    TOPSIDE: 'AUGŠPUSE', //update
    WING: 'SPĀRNS', //update
    cutAndAssemble: "Izgriez un savieno",
    beCareful: 'Esi uzmanīgs, izmantojot šķēres',
    cutOutParts: 'Izgriez daļas',
    assemble: 'Savieno',
    Assemblyguide: 'Salikšanas pamācība', //update
    fold: 'Locīšanas piemēri',
    foldGuide: 'Lokot atbalsti kartonu pret dīvānu vai kādu citu mēbeli',
    foldGuideDezeen:
      'Vairākas reizes nospied uz raustītās līnijas, lai salocītu kartonu', //update
    glue: 'Uz virsmas vienmērīgi uzklāj līmi vai līmlenti', //update
    cable: 'Izmanto savilcējus vai auklu, lai savienotu detaļas', //update
    done: 'Gatavs!',
    goBack: 'Atgriezties uz izvēlni',
  },
  CautionPage: {
    CAUTION: 'UZMANĪBU',
    needItem: 'Tev būs nepieciešami šādi darba rīki',
    children: 'Bērniem ieteicams šos uzdevumus veikt pieaugušo klātbūtnē ',
    mat:
      'Pirms ķeries pie darba, paklāj apakšā drošu materiālu, lai nesabojātu grīdas segumu.',
    doNotPutHeavyThing:
      'Izveidotie priekšmeti nav paredzēti, lai uz tiem kāptu vai sēdētu. Izvairieties uz tiem novietot smagus objektus. ',
    doNotThrow:
      'Nemetiet, nesperiet izgatavotos priekšmetus citu cilvēku vai dzīvnieku virzienā',
    stayAwayFlame: 'Turiet drošā attālumā no uguns',
    stayAwayWater: 'Nenovietojiet ūdens tuvumā vai mitrās vietās',
    mayDamaged: '* TV iepakojums var tikt bojāts piegādes laikā',
    companyDoestResponsible:
      '* Samsung nav atbildīgs par iegūtajām traumām vai bojājumiem, ja tādi rodas šo aktivitāšu laikā',
    cannotBeReturned:
      '* Preces nevar tikt atgrieztas bojāta iepakojuma dēļ',
    understand: 'Labi, sapratu',
  },
  PrivacyPolicy: {
    title: 'Privacy policy',
  },
  GoingGreen: {
    visual: {
      title: 'Zaļie risinājumi',
      text1:
        'Lai īstenotu mūsu apņemšanos, izmantot dabai draudzīgākus risinājumus, esam izstrādājuši mūsu iepakojumus, izmantojot mazāk papīra un tintes. ',
      text2:'',
      text2_special:
        '(*Augstāk minētais neattiecas uz konkrētiem modeļiem, tai skaitā Lifestyle TV)',
      text3: 'Atzīmē vēlamo, lai uzzinātu vairāk ',
    },
    greenIn: {
      title: 'Videi draudzīgs TV iepakojums',
      subtitle1: 'Meklēt produkta informāciju',
      subtitle2: 'Uzlabotais iepakojums – videi draudzīgs ',
      desc: 'Meklē pēc modeļa numura, lai uzzinātu vairāk ',
      descM: '*Nofotografē TV modeļa numuru',
      guide: 'modeļa nosaukums',
      button: 'Uzņemt attēlu',
      button2: 'Izveidot savus priekšmetus',
      product_info: 'Informācija par produktu',
    },
    search: {
      guide: 'Meklēt..',
      noResult: 'Šādu rezultātu nav',
      more: 'VAIRĀK',
      search: 'Meklēt',
      retake: 'Uzņemt citu',
      result: 'Rezultāti',
    },
    photo: {
      guide1: 'Ieraksti TV modeļa nosaukumu brīvajā teksta logā',
      guide2: '(piemēram Q800A, UT7000, RU7100 u.tml.)',
    },
  },
  searchCountrySelect: 'Izvēlies valsti, lai meklētu'
};
